// extracted by mini-css-extract-plugin
export default {"passwordInput__label":"PasswordInput_passwordInput__label__kvSSX","passwordInput__input":"PasswordInput_passwordInput__input__pEsy1"};